<template>
  <v-navigation-drawer
    color="cardSurface"
    v-model="drawer"
    fixed
    right
    temporary
    style="z-index: 9"
    width="300"
  >
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="text-h6">Innstillinger</v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn icon>
          <v-icon color="grey lighten-1" @click="drawer = !drawer">
            mdi-close
          </v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>

    <v-divider></v-divider>

    <div v-if="isKiosk && isTrysilhus" class="ma-2">
      <h4>Prosjekter</h4>
      <v-btn color="cardBtnBadge" depressed block @click="delKiosk">
        Slett kioskoppsett
        <v-icon right>mdi-delete</v-icon>
      </v-btn>
    </div>

    <v-divider v-if="isKiosk && isTrysilhus"></v-divider>

    <div v-if="deferredPrompt" class="ma-2">
      <v-btn color="cardBtnBadge" depressed block @click="install">
        Installer som app
        <v-icon right>mdi-tray-arrow-down</v-icon>
      </v-btn>
    </div>

    <v-divider v-if="deferredPrompt"></v-divider>

    <v-item-group v-model="themeMode" mandatory @change="userChangeMode">
      <v-container>
        <h4>Tema</h4>
        <v-row dense>
          <v-col v-for="(them, index) in thems" :key="index" cols="6">
            <v-item v-slot="{ active, toggle }">
              <v-btn
                :color="active ? 'primary' : 'cardBtnBadge'"
                class="pa-3 w-100"
                @click="toggle"
              >
                {{ them.name }}
                <v-icon right>{{ them.icon }}</v-icon>
              </v-btn>
            </v-item>
          </v-col>
        </v-row>
      </v-container>
    </v-item-group>

    <v-divider></v-divider>

    <div class="ma-2">
      <ChangeActiveContactDialog v-if="$vuetify.breakpoint.xs" block />
    </div>

    <div class="ma-2">
      <v-btn color="cardBtnBadge" depressed block @click="logout">
        <v-icon left>mdi-logout-variant</v-icon>
        Logg ut
      </v-btn>
    </div>
  </v-navigation-drawer>
</template>

<script lang="ts">
import Vue from "vue";
import { mapGetters } from "vuex";
import contactpersonApi from "@/api/contactpersonApi";
import { logout } from "@/helpers/logout";
import ChangeActiveContactDialog from "@/components/company/children/ChangeActiveContactDialog.vue";

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      themeMode: 0,
      deviceHaveDarkMode: false,
      thems: [
        {
          name: "System",
          icon: "mdi-theme-light-dark",
        },
        {
          name: "Lyst",
          icon: "mdi-white-balance-sunny",
          active: true,
        },
        {
          name: "Mørkt",
          icon: "mdi-weather-night",
        },
      ],
      deferredPrompt: null as any,
      logout,
    };
  },
  created() {
    if (this.profile) {
      this.getDarkModeSettings();
    }
  },
  watch: {
    async profile(value: any) {
      if (value) {
        this.getDarkModeSettings();
      }
    },
  },
  mounted() {
    this.setDarkMode();
    this.installPwa();
  },
  methods: {
    async getDarkModeSettings() {
      var valueDarkMode = await contactpersonApi.getUserSetting("BTDarkMode");
      if (valueDarkMode !== "") {
        this.themeMode = valueDarkMode;
        this.userChangeMode(valueDarkMode);
      }
    },
    installPwa() {
      window.addEventListener("beforeinstallprompt", (e) => {
        e.preventDefault();
        // Stash the event so it can be triggered later.
        this.deferredPrompt = e;
      });
      window.addEventListener("appinstalled", () => {
        this.deferredPrompt = null;
      });
    },
    async install() {
      this.deferredPrompt.prompt();
    },
    setDarkMode() {
      //Get browser/device is daarkmode
      this.deviceHaveDarkMode =
        window.matchMedia &&
        window.matchMedia("(prefers-color-scheme: dark)").matches;
      //SetDarkMode
      this.changeDarkMode(this.deviceHaveDarkMode);
      // this.userChangeMode(this.themeMode);

      //Listen for browser/device darkMode change
      window
        .matchMedia("(prefers-color-scheme: dark)")
        .addEventListener("change", (e) => {
          this.deviceHaveDarkMode = e.matches;
          this.userChangeMode(this.themeMode);
        });

      window.addEventListener("keyup", (e) => {
        if (e && e.keyCode === 113) {
          //Turn dark mode on/off with F2
          this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
        }
      });
    },
    changeDarkMode(newValue: boolean) {
      this.$vuetify.theme.dark = newValue;
    },
    async userChangeMode(value: number) {
      //0 = System
      //1 = ligth
      //2 = dark

      if (value === 0) {
        this.changeDarkMode(this.deviceHaveDarkMode);
      } else if (value === 1) {
        this.changeDarkMode(false);
      } else {
        this.changeDarkMode(true);
      }
      await contactpersonApi.putUserSetting(
        "BTDarkMode",
        JSON.stringify(value)
      );
    },
    delKiosk() {
      localStorage.setItem("kioskProjects", "null");
      logout();
      // this.$router.push({ name: "Kiosk" });
    },
  },
  computed: {
    ...mapGetters({
      profile: "shared/profile",
      isTrysilhus: "shared/isTrysilhus",
      isKiosk: "shared/isKiosk",
    }),
    drawer: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
  },
  components: {
    ChangeActiveContactDialog,
  },
});
</script>

<style lang="scss" scoped>
.v-list-item__content {
  height: calc(65px + env(safe-area-inset-top)) !important;
}
</style>
